module.exports = __webpack_public_path__ + "img/2-1.58dda6c0.png";